import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Loader} from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';
import {dateFormatReservation} from '../../../../../common/constants/datesFormat';
import User from '../popup/user';


class ReservationsModal extends Component {
  fetchData() {
    const {code} = this.props;
    this.props.fetchReserveDetailCode(code);
  }

  renderItems(list) {
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={7}>No hay datos disponibles</Table.Cell>
        </Table.Row>
      );
    }
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.dealer}</Table.Cell>
          <Table.Cell textAlign='center'>{element.agency}</Table.Cell>
          <Table.Cell textAlign='right'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.orderCode}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.date ? moment(element.date).format(dateFormatReservation) : ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <User username={element.username} />
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.status}</Table.Cell>
          <Table.Cell textAlign='center'>{element.type}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading, backOrdersData} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems(backOrdersData);
  }

  render() {
    const {quantity, backOrdersData} = this.props;

    if (!quantity) {
      return <div>{quantity}</div>;
    }
    return (
      <Modal size={'large'} onOpen={() => this.fetchData()}
        trigger={<div className='link'>
          {quantity}
        </div>} closeIcon>

        <Modal.Header>
          Reservados
          <span className='quantity-container'>
            {_.sumBy(backOrdersData, 'quantity')}
          </span>
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>

            <Table striped className='toyota-grid'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign='center'>Concesionario</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Pedido</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Fecha de Pedido</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Tipo</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
          
              <Table.Body>
                {this.renderData()}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partModals.loadingBackOrdersDetail,
    'backOrdersData': state.partModals.reserveDetail,
  };
};

const {
  fetchReserveDetailCode,
} = Actions;

export default connect(mapStateToProps, {
  fetchReserveDetailCode,
})(ReservationsModal);
